import { PageSection } from '@/types/page/props';
import casino from './pages/casino';

export const casinoSection: PageSection = {
  label: 'tab_casino',
  icon: 'fa-solid fa-slot-machine',
  pages: casino,
};

export const casinoSectionWithoutOriginals: PageSection = {
  label: 'tab_casino',
  icon: 'fa-solid fa-slot-machine',
  pages: casino.filter(page => page.label !== 'originals_label'),
};
